import { z } from 'zod';

export const messageTagTypes = [
  'business',
  'personal',
  'urgent',
  null,
  '',
] as const;

const messageTagStringSchema = z.enum(['business', 'personal', 'urgent', '']);

export const messageTagTypeSchema = z.union([
  messageTagStringSchema,
  z.literal(null),
]);

export const messageSubTagTypes = [
  'create_order',
  'modify_order',
  'cancel_order',
  'order_enquiry',
  'product_enquiry',
  'delivery_enquiry',
  'return',
  'stock_update',
  'negotiation',
  'discount',
  'payment',
  'invoice',
  'ledger',
  'credit_note',
  'refund',
  'issue',
  'support_request',
  'query',
  'unknown',
  'null',
  '',
] as const;

export const messageSubTagTypeSchema = z.enum(messageSubTagTypes);

export const messageTagSchema = z.object({
  sub_tag: messageSubTagTypeSchema,
  tag: messageTagTypeSchema,
});

export type MessageTagType = z.infer<typeof messageTagTypeSchema>;
export type MessageSubTagType = z.infer<typeof messageSubTagTypeSchema>;
export type MessageTagData = z.infer<typeof messageTagSchema>;
